<template>
  <div class="p-4">
    <section>
      <span class="fw-bolder text-primary">Wgraj plik z naczepami:</span>
      <input type="file" class="form-control" @change="onChange" />
      <xlsx-read :file="file">
        <xlsx-json :sheet="selectedSheet">
          <template #default="{collection}">
            <div v-show="collection !== null">
              <button class="btn btn-primary mt-3" @click="sendCollection(collection)">
                Wyślij naczepy do bazy
              </button>
            </div>
          </template>
        </xlsx-json>
      </xlsx-read>
    </section>
  </div>
</template>

<script>
import { XlsxRead, XlsxJson } from 'vue3-xlsx'
import axios from 'axios'
export default {
  name: 'ImportXlsxTrailers',
  components: {
    XlsxRead,
    XlsxJson
  },
  data () {
    return {
      file: null,
      isLoading: false
    }
  },
  methods: {
    onChange (event) {
      this.file = event.target.files ? event.target.files[0] : null
    },
    sendCollection (collection) {
      for (const i in collection) {
        const plateNumber = collection[i].plateNumber
        const postData = { plateNumber: plateNumber, name: plateNumber }
        axios.post(`${process.env.VUE_APP_API_BASE_URL}Trailer`, postData, { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }).catch(r => {
          console.log(r.response)
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
